"use client";

import { useTranslation } from "@/i18n/client";
import styles from "../search.module.scss";
import { JDILogin } from "@/lib/jdiClientUtils";
import { createTrackParams, EXPCONFIG_FAST } from "@/app/s/util";
import { IExpoTrackParamsRecord, EXPOSURE_RECORD, sendClickTrack } from "@/tracks/25157";

export default function SigninTips() {
  const { t } = useTranslation();
  const onClickLogin = () => {
    JDILogin.getInstance().openLoginDialog();
    sendClickTrack.Search_ProductList_Login({
      channelName: "Search_result",
    });
  };
  return (
    <div
      exptag={"exp|" + EXPOSURE_RECORD.Search_ProductList_Login_Expo}
      data-exptag-config={EXPCONFIG_FAST}
      data-exptag-json-param={createTrackParams<IExpoTrackParamsRecord["Search_ProductList_Login_Expo"]>({
        channelName: "Search_result",
      })}
      className={styles.signinTips}
    >
      <div className={styles.inner}>
        <p>{t("s.signInTips")}</p>
        <span onClick={onClickLogin}>{t("s.signIn")}</span>
      </div>
    </div>
  );
}
